'use client';

import { RefObject, useState, useEffect } from 'react';

const useRefInView = (ref: RefObject<HTMLDivElement | null>) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const isRefInView =
          ref.current.getBoundingClientRect().top <= window.innerHeight;

        setIsInView(isRefInView);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return isInView;
};

export default useRefInView;
